<template>
  <div id="app">
    <!-- <router-view /> -->
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view> -->
    <router-view></router-view>
  </div>
</template>

<script>
import { getPlatformInfo } from '@/request/app'
export default {
  name: 'App',
  created () {
    this.getPlatformInfo()
  },
  methods: {
    getPlatformInfo () {
      let url = '/account-admin-web/getSysInfo'
      getPlatformInfo(url, {}).then(res => {
        if (res.code === 0) {
          let logoArr = [{ name: '薪元', imageName: 'login_04' }, { name: '聚薪舍', imageName: 'nlogo_05' }, { name: '亮辅', imageName: 'login_01' }]
          let imageName = 'login_04'
          logoArr.forEach(e => {
            if (res.data.platform.indexOf(e.name) !== -1) imageName = e.imageName
          })
          res.data.imageName = imageName
          this.$store.dispatch('set_platformInfo', res.data)
          // console.log(document)
          document.title = res.data.platform + '共享经济综合服务平台运营端'
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.el-input__inner,
/deep/.el-button,
/deep/.el-checkbox__inner,
/deep/.el-upload-dragger,
/deep/.el-textarea__inner {
  border-width: 1px !important; /*no*/
}
</style>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
* {
  margin: 0;
  padding: 0;
}
html,
body {
  width: 100%;
  height: 100%;
  background: #f2f2f2;
  font-size: 14px;
}
ul {
  list-style: none;
}
a {
  text-decoration: none;
}
img {
  vertical-align: top;
  border: none;
}
.clearf:after,
.clearf:before {
  content: "";
  display: block;
  clear: both;
}
.derateName{
  font-size: 12px;
}
.derateCode{
  font-size: 12px;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .el-checkbox__inner:after {
    content: "";
    border: 2px solid #fff;
    border-left: 0;
    border-top: 0;
    height: 6px;
    left: 4px;
    position: absolute;
    top: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue